import * as MD from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { Autocomplete, AutocompleteRenderInputParams } from '@material-ui/lab/';
import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';
import { IApplicationState, IConnectedReduxProps } from '../../Store';
import { I18N, ILocaleInfos } from '../../Store/I18n/Types';
import { ILayoutState } from '../../Store/Layout/Types';
import { IUserState } from '../../Store/User/Types';
import { getACLParents, getACLUsers } from '../../Store/UserManagement/Actions';
import {
	IUserManagementState,
	IUserSearchParams,
	IUserSearchParamsSorting,
} from '../../Store/UserManagement/Types';
import { getTheme } from '../../Themes';
import { ButtonDensed } from '../../Themes/StyledElements';
import {
	isNullOrUndefined,
	isNullOrUndefinedOrEmptyString,
} from '../../Utils/Various';

export interface IRouterMatchParams {
	groupName: string;
	type: string;
}

interface IPropsFromState {
	i18n: I18N;
	layout: ILayoutState;
	localeInfos: ILocaleInfos;
	router: RouteComponentProps<IRouterMatchParams>;
	user: IUserState;
	userManagement: IUserManagementState;
}

interface IState {
	params: IUserSearchParams;
	parentName: string;
}

interface IPropsTheme {
	theme: any;
}

interface IPropsFromDispatch {
	getACLUsers: typeof getACLUsers;
	getACLParents: typeof getACLParents;
}

type AllProps = MD.WithStyles<typeof styles> &
	IPropsFromState &
	IPropsFromDispatch &
	RouteComponentProps<{}> &
	IPropsTheme &
	IConnectedReduxProps;

const theme = getTheme();
const styles = MD.createStyles({
	drawerUserPaper: {
		width: theme.UserManagement.dimensions.drawerWidth,
		paddingTop: '14px',
		paddingLeft: '15px',
		paddingRight: '15px',
		backgroundColor: theme.palette.background.default,
	},
	launchSearch: {
		marginTop: '20px',
	},
	formControl: {
		margin: theme.spacing(3),
	},
	formLabel: {
		marginBottom: theme.spacing(2),
	},
});

export class DrawerUserComponent extends React.Component<AllProps, IState> {
	public constructor(props: AllProps) {
		super(props);
		this.state = {
			parentName: '',
			params: {
				isGroup: this.props.router.match.params.type === 'groups',
				researchText: '',
				showInactive: false,
				usersParentID:
					this.props.user.groupID === 2 ? 0 : this.props.user.groupID,
				createdAfter: undefined,
			},
		};
	}

	public render(): React.ReactNode {
		const { classes } = this.props;
		return (
			<MD.FormGroup>
				<MD.InputLabel htmlFor="standard-adornment-amount">
					{this.props.router.match.params.type === 'groups'
						? this.props.i18n._('Research in Groups')
						: this.props.i18n._('Research in Users')}
				</MD.InputLabel>
				<MD.Input
					id="standard-adornment-amount"
					value={this.state.params.researchText}
					onChange={(event: any) => {
						this.setState({
							...this.state,
							params: {
								...this.state.params,
								researchText: event.target.value,
							},
						});
					}}
					startAdornment={
						<MD.InputAdornment position="start">
							<SearchIcon />
						</MD.InputAdornment>
					}
				/>
				<MD.FormControlLabel
					control={
						<MD.Switch
							checked={this.state.params.showInactive}
							onChange={(
								event: React.ChangeEvent<HTMLInputElement>
							) => {
								this.setState({
									...this.state,
									params: {
										...this.state.params,
										showInactive: event.target.checked,
									},
								});
							}}
							name="isActive"
						/>
					}
					label={
						this.props.router.match.params.type === 'groups'
							? this.props.i18n._('Display inactive groups')
							: this.props.i18n._('Display inactive users')
					}
				/>
				{this.props.router.match.params.type === 'groups'
					? ''
					: this.props.user.groupID === 2
					? this.usersResearchParams()
					: ''}
				<ButtonDensed
					style={{ marginTop: '30px' }}
					className={classes.launchSearch}
					color="secondary"
					variant="contained"
					onClick={(
						event: React.MouseEvent<HTMLButtonElement, MouseEvent>
					) => {
						this.props.getACLUsers(
							this.props.user.token,
							{
								isGroup:
									this.props.router.match.params.type ===
									'groups',
								researchText: this.state.params.researchText,
								showInactive: this.state.params.showInactive,
								usersParentID: this.state.params.usersParentID,
							},
							null
						);
					}}
				>
					{this.props.i18n._('Launch search')}
				</ButtonDensed>
				<ButtonDensed
					style={{ marginTop: '15px' }}
					className={classes.launchSearch}
					color="primary"
					variant="contained"
					onClick={(
						event: React.MouseEvent<HTMLButtonElement, MouseEvent>
					) => {
						this.props.getACLUsers(
							this.props.user.token,
							{
								isGroup:
									this.props.router.match.params.type ===
									'groups',
								researchText: '',
								showInactive: false,
								usersParentID: 0,
							},
							null,
							50,
							0
						);
						this.setState({
							...this.state,
							params: {
								...this.state.params,
								showInactive: false,
								researchText: '',
								usersParentID: 0,
							},
						});
					}}
				>
					{this.props.i18n._('Reset search')}
				</ButtonDensed>
			</MD.FormGroup>
		);
	}

	public usersResearchParams(): React.ReactNode {
		return (
			<React.Fragment>
				<Autocomplete
					options={this.props.userManagement.parentsACLData}
					onChange={(ev: React.ChangeEvent<{}>, val: any) => {
						if (
							!isNullOrUndefined(val) &&
							!isNullOrUndefinedOrEmptyString(val.name)
						) {
							this.setState({
								...this.state,
								parentName: val.name,
								params: {
									...this.state.params,
									usersParentID: val.id,
								},
							});
						} else {
							this.setState({
								...this.state,
								parentName: '',
								params: {
									...this.state.params,
									usersParentID: 0,
								},
							});
						}
					}}
					getOptionLabel={(option) => option.name}
					renderInput={(params: AutocompleteRenderInputParams) => (
						<MD.TextField
							{...params}
							label={this.props.i18n._('Research Parent')}
							value={this.state.parentName}
							onChange={(ev: any) => {
								this.props.getACLParents(
									this.props.user.token,
									ev.target.value
								);
							}}
						/>
					)}
				/>
			</React.Fragment>
		);
	}
}

const mapStateToProps = (
	{ i18n, layout, router, user, userManagement }: IApplicationState,
	ownProps: RouteComponentProps<IRouterMatchParams>
) => ({
	i18n: i18n.i18n,
	localeInfos: i18n.localeInfos,
	layout,
	router: ownProps,
	user,
	userManagement,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	getACLUsers: (
		token: string,
		params: IUserSearchParams | null,
		paramsSorting: IUserSearchParamsSorting | null,
		resultsPerPage?: number,
		page?: number
	) =>
		dispatch(
			getACLUsers(token, params, paramsSorting, resultsPerPage, page)
		),
	getACLParents: (token: string, researchField: string) =>
		dispatch(getACLParents(token, researchField)),
});

export const DrawerUser = connect(
	mapStateToProps,
	mapDispatchToProps
)(MD.withTheme(MD.withStyles(styles)(DrawerUserComponent)));
